export default "__VITE_ASSET__Bp95OB49__"